import {getApi} from '../../modules/common/utils/api'

const api = getApi('reservation')

export function postConfiguration(data) {
  return api.post(`v1/configurations`, data)
}

export function getConfiguration({group_id}, entityObjectId) {
  return api.get(
    'v1/configurations/' +
      group_id +
      '/reservation_config' +
      (entityObjectId != null ? '?entity_object_id=' + entityObjectId : ''),
    {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
      },
    }
  )
}

export function getReservedForFields(group_id) {
  return api.get(`v1/configurations/step_action_fields`, {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0',
    },
  })
}

export function getApprovalManagerGroupIds() {
  return api.get(`v1/configurations/approval_manager_groups`, {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0',
    },
  })
}

export function createReservation(data) {
  return api.post(`v1/confirmation`, data)
}

export function editReservation(data) {
  return api.put(`v1/update_confirmation`, data)
}

export function getConfigurations() {
  return api.get(`v1/configurations/config_list`)
}

export function createReservationNextStepAction(data) {
  return api.post(`v1/next_action_step`, data)
}
export function removeReservationFilters(data) {
  return api.post(`v1/temp_delete_filter`, data)
}
